import type { STATEPREFIXTYPE } from '../prefix';
import * as actionActions from './core/action';
import * as auditTrailActions from './core/audit-trail';
import * as authActions from './core/auth';
import * as candidateActions from './core/candidate';
import * as collationOfficerActions from './core/collationofficer';
import * as consistuencyActions from './core/consistuency';
import * as countryStateActions from './core/country-state';
import * as electionActions from './core/election';
import * as electionCycleActions from './core/election-cycle';
import * as electionOfficialActions from './core/election-official';
import * as electionTypeActions from './core/election-type';
import * as electiveCategoryActions from './core/elective-category';
import * as geozoneActions from './core/geozone';
import * as lgaActions from './core/lga';
import * as notificationActions from './core/notification';
import * as partyActions from './core/party';
import * as poolingUnitActions from './core/poolingunit';
import * as presidingOfficerActions from './core/presiding-officer';
import * as quickActionActions from './core/quick-actions';
import * as reportActions from './core/report';
import * as resultAnalyticsActions from './core/result-analytics';
import * as roleActions from './core/role';
import * as searchActions from './core/search';
import * as subscriptionActions from './core/subscription';
import * as userActions from './core/user';
import * as volunteerActions from './core/volunteer';
import * as wardActions from './core/ward';
import * as zoneActions from './core/zone';
import * as aggregationActions from './data/aggregation';
import * as globalActions from './global';
import * as irevActions from './query/irev';
import * as resultActions from './query/result';

function prefixFunctionKeys<T extends Record<string, (...args: any[]) => any>, P extends STATEPREFIXTYPE>(
	obj: T,
	prefix: P
): { [K in keyof T as `${P}_${string & K}`]: T[K] } {
	const result = {} as any;
	for (const key in obj) {
		result[`${prefix}_${key}`] = obj[key];
	}
	return result;
}

export const actions = {
	...prefixFunctionKeys(authActions, 'auth'),
	...prefixFunctionKeys(zoneActions, 'zone'),
	...prefixFunctionKeys(countryStateActions, 'state'),
	...prefixFunctionKeys(lgaActions, 'lga'),
	...prefixFunctionKeys(electionCycleActions, 'electioncycle'),
	...prefixFunctionKeys(electionTypeActions, 'electiontype'),
	...prefixFunctionKeys(electionOfficialActions, 'electionofficial'),
	...prefixFunctionKeys(electionActions, 'election'),
	...prefixFunctionKeys(electiveCategoryActions, 'electivecategory'),
	...prefixFunctionKeys(consistuencyActions, 'constituency'),
	...prefixFunctionKeys(actionActions, 'action'),
	...prefixFunctionKeys(candidateActions, 'candidate'),
	...prefixFunctionKeys(collationOfficerActions, 'collationofficer'),
	...prefixFunctionKeys(wardActions, 'ward'),
	...prefixFunctionKeys(resultAnalyticsActions, 'resultanalytics'),
	...globalActions,
	...userActions,
	...roleActions,
	...presidingOfficerActions,
	...poolingUnitActions,
	...partyActions,
	...geozoneActions,
	...resultActions,
	...irevActions,
	...searchActions,
	...quickActionActions,
	...reportActions,
	...volunteerActions,
	...aggregationActions,
	...auditTrailActions,
	...subscriptionActions,
	...notificationActions,
};
